// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1NRoc","label":"SetPasswdForm_label__2mw0R"};